export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_22-b28613657134461ca5d6431e08cf6ddc.jpg";